import React from 'react';
import { useSelector, useDispatch } from 'hooks';

import { getMFAData, isKioskNotPrepared } from 'modules/auth/selectors';
import { dismissMobilityWarning } from 'modules/auth/actions';
import { isFlowTypeModalVisible } from 'modules/selfServices/selectors';

import Verify from './Verify';
import FlowTypeModal from '../ui/FlowTypeModal';
import MobilityNotPreparedModal from './MobilityNotPreparedModal';

import type PageBaseProps from '../../types/PageBase';

const LoginVerify: React.FC<PageBaseProps> = (props) => {
  const dispatch = useDispatch();
  const mfaData = useSelector(getMFAData);
  const kioskNotPrepared = useSelector(isKioskNotPrepared);
  const isFlowTypeModalOpen = useSelector(isFlowTypeModalVisible);

  const [displayMobilityWarning, setDisplayMobilityWarning] = React.useState(kioskNotPrepared);

  const handleCloseMobilityWarning = React.useCallback(() => {
    setDisplayMobilityWarning(false);
    // we're adding this dispatch as, without the Verify nothing block the natural navigation for code login.
    // in the scope of having a unprepared kiosk.
    dispatch(dismissMobilityWarning());
  }, [dispatch]);

  return (
    <>
      {mfaData && <Verify {...props} />}
      {isFlowTypeModalOpen && <FlowTypeModal />}
      {displayMobilityWarning && <MobilityNotPreparedModal onClose={handleCloseMobilityWarning} />}
    </>
  );
};

export default LoginVerify;
